import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

export const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
`;

export const marginBottom = css`
  margin-bottom: 1rem;
`;

export const serviceTerms = css`
  margin-bottom: 1rem;
  background-color: ${colors.backgroundWhite};
  border-radius: 3px;
  padding: 0.5rem;
`;

export const Row = css`
  display: flex;
  width: 100%;
  ${marginBottom}

  @media (max-width: ${dimensions.phoneMax}) {
    flex-direction: column;
  }
`;

export const margin = css`
  margin-right: 1rem;

  @media (max-width: ${dimensions.phoneMax}) {
    margin-right: 0;
    ${marginBottom};
  }
`;

export const designationRow = css`
  display: flex;
  align-items: center;
  width: 100%;
  ${marginBottom}
  margin-top: 1rem;
`;

export const textAlign = css`
  text-align: left;
`;

export const noStyleButton = css`
  color: ${colors.info};
  padding: 0;
  word-break: break-word;
  text-decoration: underline;
`;
